import React from "react";
import { Tooltip } from 'antd';
import styles from "./scss/drafts.module.scss";
import NoMessage from "../chatWidgets/noMessage";
import { draftContact, initialStateModel, leftsideChats } from "../../../models/model";
import { useSelector } from "react-redux";
import { ChatService } from "../../../base/chatService";
import {DraftService} from '../../../base/draftService';
import { SocketChatService } from "../../../base/socketChatService";
import { filesUploadApiSocket, generateChatID, userInfo } from "../../../base/socketChatService/utils";
import { useHistory } from "react-router";
import ProfileAvatarGroup from "./profileavatargroup";
import { excelMimeFormats, getRecentDateFormat, imageFormat, mp3Formats, pptFormats, wordMimeFormats, zipMimeFormats } from "../../../base/utils";
import iconpdf from "../../../styles/images/grid_pdf.svg";
import iconppt from "../../../styles/images/grid_ppt.svg";
import iconword from "../../../styles/images/grid_word.svg";
import iconxls from "../../../styles/images/grid_xls.svg";
import iconzip from "../../../styles/images/grid_zip.svg";
import iconxd from "../../../styles/images/grid_xd.svg";
import iconmusic from "../../../styles/images/wave-thumbnail.svg";
import usercircle from "../../../styles/images/user-circle.svg";
import { NewDraftNotSelected, updateFileAttach } from "../../../base/socketChatService/newChat";


export default function DraftListsLeft(props:any) {
  const history = useHistory();
  const setFilteredLayer = ()=>{
    props.setFilteredLayer("default");
  };
  const contactList: leftsideChats = useSelector((state: initialStateModel) => state.recentchatReducer);
  //const chatSocket = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  //const contactListAll: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const draftContactList = contactList.draftContact;
  
  return (
    <>

      <div className={styles.draftlistmain}>
        <div className={styles.rightbartop}>
          <div className={styles.lefts}>
            Drafts <b>{draftContactList.length}</b>
          </div>
          <div className={styles.rights} onClick={()=>ChatService.editDraft('')}>
            <Tooltip mouseEnterDelay={0.5}  placement="top" title="Close">
              <span className="icon_close" onClick={setFilteredLayer}></span></Tooltip>
          </div>
        </div>
        {/* ${((chatWindowDetails?.sip_login_id === value?.contactDetail?.sip_login_id)&&(chatWindowDetails?.team_id === value?.contactDetail?.team_id) )? styles.ifNewDraft:''}
        */}
        <div className={styles.rightbarbottom}>
          {Array.isArray(props?.draftContacts) && props?.draftContacts.length===0 && <NoMessage setFilteredLayer={setFilteredLayer}/>}
          {Array.isArray(props?.draftContacts) && props?.draftContacts.length>0 &&
          props?.draftContacts.map((value:draftContact, index:number)=>{
            return(<div className={`${styles.draftlistlist}`} key={index}>
              <div className={styles.draftinners}>
                <div className={styles.hoverdiv}>
                  <ul>
                    <li onClick={()=>{
                       var chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
                       const timer = setTimeout(()=>{
                         if(value?.contactDetail && Object.keys(value?.contactDetail).length>0){
                          DraftService.removeDraftMessage(value?.contactDetail);
                          let chatDetail ={chatId:generateChatID(userInfo().fromID, value?.contactDetail?.sip_login_id?.toString())};
                          if(value?.contactDetail !== 'newWindow'){
                         chatService.openChatWindow(value?.contactDetail,history,chatDetail,'contactpage');
                          }
                         } else {
                          DraftService.deleteDraftMessage(value.id);
                         }
                         chatService.toastUndo("","")},3000);
                       chatService.toastUndo("1 Message deleted",timer, 'deleteChat');
                      
                      ChatService.editDraft('');}}>
                      <Tooltip overlayClassName="tooltipdropdownbtm" mouseEnterDelay={0.5} placement="top" title="Delete Draft">
                        <span className="icon_delete"></span></Tooltip></li>
                    <li onClick={()=>{
                      var chatService = new SocketChatService(userInfo()?.fromID, userInfo()?.domainId);
                      if(value?.contactDetail?.sip_login_id || value?.contactDetail?.team_id){
                        let chatDetail ={chatId:generateChatID(userInfo().fromID, value?.contactDetail?.sip_login_id?.toString())};
                        chatService.openChatWindow(value?.contactDetail,history,chatDetail);
                        if(value?.files && Array.isArray(value.files) && value?.files?.length>0){
                          updateFileAttach(value?.files);
                        }
                      } else {
                        NewDraftNotSelected(history);
                      }
                      
                      ChatService.editDraft(value?.id);
                      }}>
                      <Tooltip mouseEnterDelay={0.5}  placement="top" title="Edit Draft">
                        <span className="icon_editpen"></span></Tooltip></li>
                   {(value?.contactDetail?.sip_login_id || value?.contactDetail?.team_id) &&<li onClick={()=>{
                      var chatService = new SocketChatService(userInfo()?.fromID, userInfo()?.domainId);
                      if(value?.contactDetail && Object.keys(value?.contactDetail).length>0){
                      DraftService.removeDraftMessage(value?.contactDetail);
                      } else {
                        DraftService.deleteDraftMessage(value?.id);
                       }
                      if(value?.contactDetail?.sip_login_id){
                        let chatDetail ={chatId:generateChatID(userInfo().fromID, value?.contactDetail?.sip_login_id?.toString())};

                        if(value.files){
                          filesUploadApiSocket(value?.files, value?.msgText);
                          chatService.openChatWindow(value?.contactDetail,history,chatDetail);
                        } else {
                          chatService.NewChat(value?.msgText,null);
                          chatService.openChatWindow(value?.contactDetail,history,chatDetail);
                        }
                        
                      } else  if(value?.contactDetail?.team_id){
                        chatService.openChatWindow(value?.contactDetail,history);
                        chatService.sendGroupChat(value?.msgText,value.contactDetail);
                      }
                      
                      ChatService.editDraft('');}}>
                      <Tooltip mouseEnterDelay={0.5}  placement="top" title="Send Message">
                        <span className="icon_sendoutline"></span></Tooltip></li>}
                  </ul>
                </div>
                <div className={styles.toplayer}>
                {(value.contactDetail?.sip_login_id || value?.contactDetail?.team_id) ?<ProfileAvatarGroup contactDetail={value?.contactDetail} profileSize={38}></ProfileAvatarGroup>:   
                <div className={styles.lefts}>
                  <img src={usercircle} alt="" />
                  <h3>Select Contact</h3>
                </div>}
               

                {/* {!value.contactDetail?.team_id ?
               <URAvatarGroup className='lefts size38'
               profileInfo={
               (value.contactDetail?.ImageURL !== null && value.contactDetail?.ImageURL !== "") ?
               (<>
               <img src={value.contactDetail?.ImageURL} alt="" />
               <URStatusDot className={ userStatusColor(value.contactDetail?.user_status,'big')} /></>) :
               (<>
               <span>{value.contactDetail?.caller_id?.charAt(0).toUpperCase()} </span>
               <URStatusDot className={ userStatusColor(value.contactDetail?.user_status,'big')} />
               </>)
               } /> :
               value.contactDetail?.team_id && teamMemberNames?.length > 3 ?
                <URAvatarGroup className='lefts size38 four'
                  profileInfo={<><span>{teamMemberNames[0]=== undefined ? 1 :
                    teamMemberNames[0]?.charAt(0).toUpperCase()}
                  </span><span>{teamMemberNames[1]=== undefined ? 1 :teamMemberNames[1]?.charAt(0).toUpperCase()}</span>
                  <span>{teamMemberNames[2]=== undefined ? 1 : teamMemberNames[2]?.charAt(0).toUpperCase()}</span><span>
                    { teamMemberNames?.length - 3}</span></>}
                /> :value.contactDetail?.team_id && teamMemberNames?.length  === 3 ?
                  <URAvatarGroup className='lefts size38 three'
                    profileInfo={<><span>{teamMemberNames[0]=== undefined ? 1 :
                      teamMemberNames[0]?.charAt(0).toUpperCase()}</span>
                    <span>{teamMemberNames[1]=== undefined ? 1 :teamMemberNames[1]?.charAt(0).toUpperCase()}</span>
                    <span>{teamMemberNames[2]=== undefined ? 1 : teamMemberNames[2]?.charAt(0).toUpperCase()}</span></>}
                  />:value.contactDetail?.team_id && teamMemberNames?.length  === 2 ?
                    <URAvatarGroup className='lefts size38 two'
                      profileInfo={<><span>{teamMemberNames[0]=== undefined ? 1 :
                        teamMemberNames[0]?.charAt(0).toUpperCase()}</span>
                      <span>{teamMemberNames[1]=== undefined ? 1 :
                        teamMemberNames[1]?.charAt(0).toUpperCase()}</span></>}
                    />:<URAvatarGroup className={`lefts size38 colorBG`}
                      profileInfo={ <> {value.contactDetail?.image   ?
                        <img src={value.contactDetail?.image} alt="" />
                        :<span>{value.contactDetail?.caller_id?.charAt(0).toUpperCase()}</span> } </>  }
                    />
            } */}

                  {/* <URAvatarGroup className='lefts size38'
                    profileInfo={<>
                      {value.contactDetail.ImageURL && <img src={value.contactDetail.ImageURL} alt="" />}
                      {!value.contactDetail.ImageURL && <span>
                        {value.contactDetail?.caller_id?.substring(0,1)}</span>
                      }
                      <URStatusDot  className={userStatusColor(value?.contactDetail?.user_status,'small')}/>
                    </>}/> */}

{(value?.contactDetail?.caller_id || value.contactDetail?.team_name) && <div className={styles.middle}>
                    <h4>{value?.contactDetail?.caller_id || value.contactDetail?.team_name}</h4>
                  </div>}
                  <div className={styles.rights}>
                    <p>{getRecentDateFormat(value?.timeStamp)}<br/><span>Draft</span></p>
                  </div>
                </div>
                <div className={styles.topbottomlayer}>
                  <p  dangerouslySetInnerHTML={{ __html: value.msgText }}></p>
                  {Array.isArray(value?.files) && value?.files?.length>0 && value.files.map((file:any,index:any)=><img key={index} src={
                    imageFormat.indexOf(file?.fileType)>-1? file?.filePath :
                    mp3Formats.indexOf(file?.fileType)>-1 ? iconmusic :
                    wordMimeFormats.indexOf(file?.fileType)>-1? iconword :
                    pptFormats.indexOf(file?.fileType)>-1
                      ? iconppt: file?.fileType==="application/pdf"?
                        iconpdf:excelMimeFormats.indexOf(file?.fileType)>-1
                          ?iconxls: zipMimeFormats.indexOf(file?.fileType)>-1 ? iconzip : iconxd
                  } alt="fileName" />)}
         

                </div>
              </div>
            </div> ); })}

          {/* <div className={styles.draftlistlist}>
            <div className={styles.draftinners}>
              <div className={styles.hoverdiv}>
                <ul>
                  <li><span className="icon_editpen"></span></li>
                  <li><span className="icon_delete"></span></li>
                  <li><span className="icon_sendoutline"></span></li>
                </ul>
              </div>
              <div className={styles.toplayer}>
                <div className={styles.lefts}>
                  <h3>TO: Not Selected</h3>
                </div>
                <div className={styles.rights}>
                  <p>30 min ago<br/><span>Draft</span></p>
                </div>
              </div>
              <div className={styles.topbottomlayer}>
                <p>We’ve invited you to the spreadsheet we did yesterday, but in
                  case we will put it here for u guys me know, if everything seems to be
                  clear for you. We can schedule the hangout meeting late, if you want.</p>
              </div>
            </div>
          </div> */}

        </div>
      </div>

    </>
  );
};

